const intersectionObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        intersectionObserver.unobserve(entry.target);
        entry.target.dataset.scrollTrigger = "true";
      }
    });
  },
  { threshold: 0.5 }
);

const scrollTrigger = () => ({
  init() {
    this.$el.dataset.scrollTrigger = "";
    intersectionObserver.observe(this.$el);
  },

  destroy() {
    intersectionObserver.unobserve(this.$el);
  }
});

export default scrollTrigger;
